import { updateObject } from 'utils/updateObject'
import setFilters from 'store/reducer-utils/setFilters'
import {
  MAIN_FILTERS_APPLY,
  SET_ADVERTISING_TYPES,
  SET_FILTERS,
  SET_LOADING,
  SET_NETWORKS_LIST,
} from 'modules/Services/types'

const initialState = {
  loading: true,
  networks: [],
  filters: null,
  advertisingTypes: [],
}

const setNetworks = (state, { payload }) => updateObject(state, payload)

const toggleLoading = (state, { payload }) => updateObject(state, payload)

const setNetworksListFilters = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const applyFilters = (state, { payload }) => updateObject(state, { filters: payload })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return toggleLoading(state, action)
    case SET_NETWORKS_LIST:
      return setNetworks(state, action)
    case SET_FILTERS:
      return setNetworksListFilters(state, action)
    case SET_ADVERTISING_TYPES:
      return updateObject(state, { advertisingTypes: action.payload })
    case MAIN_FILTERS_APPLY:
      return applyFilters(state, action)
    default:
      return state
  }
}

export default reducer
